import React from 'react';
import { Box, IconButton, Tooltip, useTheme, useMediaQuery } from '@mui/material';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import TelegramIcon from '@mui/icons-material/Telegram';
import PhoneIcon from '@mui/icons-material/Phone';

const FloatingButtons = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const buttons = [
    {
      icon: WhatsAppIcon,
      label: 'WhatsApp',
      href: 'https://wa.me/905435056559',
      color: '#25D366',
    },
    {
      icon: TelegramIcon,
      label: 'Telegram',
      href: 'https://t.me/905435056559',
      color: '#0088cc',
    },
    {
      icon: PhoneIcon,
      label: 'Hemen Ara',
      href: 'tel:+905435056559',
      color: theme.palette.secondary.main,
    },
  ];

  return (
    <Box
      sx={{
        position: 'fixed',
        right: isMobile ? '20px' : '40px',
        bottom: isMobile ? '20px' : '40px',
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        zIndex: 1000,
      }}
    >
      {buttons.map((button, index) => (
        <Tooltip
          key={button.label}
          title={button.label}
          placement="left"
          arrow
        >
          <IconButton
            component="a"
            href={button.href}
            target={button.icon !== PhoneIcon ? '_blank' : '_self'}
            rel="noopener noreferrer"
            sx={{
              backgroundColor: 'white',
              color: button.color,
              width: isMobile ? 60 : 70,
              height: isMobile ? 60 : 70,
              boxShadow: '0px 4px 16px rgba(0, 0, 0, 0.15)',
              '&:hover': {
                backgroundColor: 'white',
                transform: 'scale(1.1)',
                boxShadow: '0px 8px 20px rgba(0, 0, 0, 0.2)',
              },
              transition: 'all 0.3s ease',
            }}
          >
            <button.icon sx={{ fontSize: isMobile ? 32 : 36 }} />
          </IconButton>
        </Tooltip>
      ))}
    </Box>
  );
};

export default FloatingButtons; 